import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const DocumentModal = (props) => {
  const {
    buttonLabel,
    children,
    className,
    href,
    DocumentComponent,
    tag: Tag = Link,
    buttonClassName
  } = props;
  const  { t } = useTranslation('common')
  const [modal, setModal] = useState(false);
  const text = children || buttonLabel;
  const toggle = () => setModal(!modal);

  return (
    <div className="d-inline">
      <Tag onClick={toggle} className={buttonClassName} href={href}>{text}</Tag>
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>{text}</ModalHeader>
        <ModalBody className="modal-height">
         <DocumentComponent />
        </ModalBody>
        <ModalFooter>
          <div className="mx-auto">
            <Button color="secondary" onClick={toggle}>{t('actions.close')}</Button>
          </div>  
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default DocumentModal;